// Endpoint
export const DegreeEndPoint = {
  GET: 'admin/degree/list',
  CREATE: 'admin/degree/create',
  DETAIL: 'admin/degree/by-id',
  UPDATE: 'admin/degree/update',
  DELETE: 'admin/degree/delete',
  TOTAL: 'admin/degree/count',
}
